import Vue from 'vue';

Vue.component('youtube-button', {
  props: {
    youtubeId: {
      type: String,
      required: true
  	},
	autoPlay: {
		type: Boolean,
		default: false,
	},
  },
  methods: {
    play: function() {
      this.$store.dispatch('youtube/play', { youtubeId: this.youtubeId, autoPlay: this.autoPlay });
    },
  },
  template: `
    <button class="btn btn--dark-blue" @click="play"><slot></slot></button>
  `
})



// WEBPACK FOOTER //
// ./components/youtube/youtube-button.js